import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import CalendarViewModelType from '@/ViewModels/Controls/CalendarViewModel';
import LinkType from '@/Controls/Link';
import ResourceManager from '@/Management/ResourceManager';
import Utilities from '@/Utility/Utilities';

export default class Calendar extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private jQueryControl: JQuery;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.Calendar>;

    public constructor(private viewModel: CalendarViewModelType, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><div class="inner"></div></div>');

        const language = ResourceManager.getInstance().getLanguage();

        this.applyBindings(this.jQueryControl.find('.inner'), {
            kendoCalendar: {
                animation: this.viewModel.animation,

                value: this.viewModel.date,

                culture: language.cultureInfoName,

                min: this.viewModel.min,

                max: this.viewModel.max,

                format: language.datePattern,

                widget: this.widget
            },

            focus: this.viewModel.isFocusable,

            enable: this.viewModel.isEnabled,

            attr: {
                placeholder: language.datePattern
            }
        });

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: kendo.ui.Calendar): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'calendar',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            invalid: this.viewModel.invalidationText,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            interact: this.viewModel.isEnabled,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        if (!Utilities.isNullOrUndefined(this.viewModel.locator)) {
            this.assignLocators();
            widget.bind('navigate', this.assignLocators.bind(this));
        }
    }

    private assignLocators(): void {
        let wrapper: JQuery = this.widget().wrapper;
        this.applyBindings(wrapper, {
            autoLocator: this.defineComputed(() => {
                return this.viewModel.locator();
            })
        });
        let header = wrapper.find('.k-header');
        this.applyBindings(header.children('.k-nav-prev'), {
            autoLocator: this.defineComputed(() => {
                return this.viewModel.locator() + '.prev';
            })
        });
        this.applyBindings(header.children('.k-nav-next'), {
            autoLocator: this.defineComputed(() => {
                return this.viewModel.locator() + '.next';
            })
        });
        this.applyBindings(header.children('.k-nav-fast'), {
            autoLocator: this.defineComputed(() => {
                return this.viewModel.locator() + '.fast';
            })
        });
        let footer = wrapper.find('.k-footer');
        this.applyBindings(footer.children('.k-nav-today'), {
            autoLocator: this.defineComputed(() => {
                return this.viewModel.locator() + '.today';
            })
        });
        let content = wrapper.find('.k-content');
        content.find('tbody td > a[data-value]').each((index: number, element: HTMLElement) => {
            let link = $(element);
            let date = link.attr('data-value');
            let cell = link.parent();

            this.applyBindings(cell, {
                autoLocator: this.defineComputed(() => {
                    return this.viewModel.locator() + '.[' + date + ']';
                })
            });
        });
    }
}

ComponentManager.setControl('Calendar', Calendar, 'RADPresentation.HTMLClient.DefaultViewExtensions');